
































import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import BcSyncConsoleTabsNav from '../components/sync-console/sync-console-tabs-nav.vue';
const BcSaleDaysSyncTable = () => import('../components/sync-console/sale-days-sync-table.vue');

@Component({
  name: 'bpc-sync-console',
  components: {
    'bpc-content-wrapper': ContentWrapper,
    BcSyncConsoleTabsNav,
    BcSaleDaysSyncTable,
  },
})
export default class SyncConsolePage extends Vue {
  currentTab: string = 'pos-session';

  get actionsPortalTarget() {
    return `sync-console-actions-${this.$bpcHelper.generateUUIDv4()}`;
  }
}
